const ICON_CLASS = 'block h-4 w-4 shrink-0'

export const InfoCircleIcon = ({ className = ICON_CLASS }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" />
    <path strokeLinecap="round" d="M12 10.5v5.5" />
    <circle cx="12" cy="7.75" r="0.9" fill="currentColor" stroke="none" />
  </svg>
)

export default InfoCircleIcon
